import { TrialBalanceTableBalance } from '../types/tableTypes'

export const getBalanceByType = (balances: TrialBalanceTableBalance[], type: string) =>
  balances?.find((balance) => balance.type === type)?.balance ?? null
